/**The basic reducer used throughout the application. Allows for in depth state updates, and easy access to disabling the UI during processing.
 * 
 * @param {*} state 
 * @param {*} action 
 * @returns 
 */
const reducer = (state, action) => {
    switch (action.type) {
        case 'update':
            return { ...state, ...action.newState };
        case 'doingAjax':
            return { ...state, isDoingAjax: true };
        case 'ajaxDone':
            return { ...state, isDoingAjax: false };
        default:
            return state;
    }
};

export default reducer;
